import OnSiteFeeSwitch from './OnSiteFeeSwitch';
import ServiceFeeLocalAmount from './ServiceFeeLocalAmount';
import ServiceFeeRevenueCalculator from './ServiceFeeRevenueCalculator';

export default {
  OnSiteFeeSwitch,
  ServiceFeeLocalAmount,
  ServiceFeeRevenueCalculator,
};
